import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { innskraningUrlEnum } from 'stores/onboarding/data'

import s from './Step.module.scss'

const c = classnames.bind(s)

export type StepProps = {
  text: string
  url: string
  isClickable: boolean
  activeStep: number
  index: number
}

export const Step = ({
  text,
  url,
  index,
  activeStep,
  isClickable,
}: StepProps) => {
  const router = useRouter()
  const Wrap = isClickable ? 'button' : 'div'

  //TODO: set aria-controls when  `isClickable===true`

  return (
    <Wrap
      className={c(s.step, {
        current: index === activeStep,
        isClickable: isClickable,
      })}
      onClick={
        isClickable
          ? () => {
              router.push(innskraningUrlEnum.LOGIN, url)
            }
          : undefined
      }
    >
      <div>
        <span className={s.step__number}>Skref {index + 1}</span>
        <span className={s.step__text}>{text}</span>
      </div>
    </Wrap>
  )
}
